import { BaseResponse } from '../../../../types/api/api.types';
import { FORM_ENDPOINTS } from '../../../../utils/api/endpoints/formEndpoints';
import { ContactFormSchema } from './Contact.types';

const PREFIX = '[contactMessageQuery]';

export const CONTACT_MESSAGE_QUERY_KEY = 'CONTACT_MESSAGE';

export const contactMessageQuery = async (data: ContactFormSchema) => {
  console.log(PREFIX, `Sending contact message...`);
  const response = await FORM_ENDPOINTS.sendMessageCOntact(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Contact message sent.`);
  return json as BaseResponse;
};
